import { createFeature, createReducer, on } from '@ngrx/store';

import { EscalationConfigurationActions } from './escalation-configuration.actions';
import { initialEscalationConfigurationState } from './escalation-configuration.state';
import { sortEscalationLevels } from './escalation-configuration.utils';

export const escalationConfigurationFeature = createFeature({
  name: 'escalationConfiguration',
  reducer: createReducer(
    initialEscalationConfigurationState,
    on(EscalationConfigurationActions.loadSettings, (state) => ({
      ...state,
      loading: true,
      error: null,
    })),
    on(
      EscalationConfigurationActions.loadSettingsSuccess,
      (state, { configurationId, escalationEnabled, escalationLevels }) => ({
        ...state,
        configurationId,
        escalationEnabled,
        escalationLevels: sortEscalationLevels(escalationLevels),
        loading: false,
      }),
    ),
    on(EscalationConfigurationActions.loadSettingsFailure, (state, { error }) => ({
      ...state,
      loading: false,
      error,
    })),
    on(EscalationConfigurationActions.saveSettings, (state) => ({
      ...state,
      saving: true,
      error: null,
      successMessage: null,
    })),
    on(
      EscalationConfigurationActions.saveSettingsSuccess,
      (state, { message, configurationId, escalationEnabled, escalationLevels }) => ({
        ...state,
        configurationId,
        escalationEnabled,
        escalationLevels: sortEscalationLevels(escalationLevels),
        saving: false,
        successMessage: message,
      }),
    ),
    on(EscalationConfigurationActions.saveSettingsFailure, (state, { error }) => ({
      ...state,
      saving: false,
      error,
    })),
    on(EscalationConfigurationActions.updateEscalationStatus, (state) => ({
      ...state,
      saving: true,
      error: null,
      successMessage: null,
    })),
    on(
      EscalationConfigurationActions.updateEscalationStatusSuccess,
      (state, { message, escalationEnabled }) => ({
        ...state,
        escalationEnabled,
        saving: false,
        successMessage: message,
      }),
    ),
    on(EscalationConfigurationActions.updateEscalationStatusFailure, (state, { error }) => ({
      ...state,
      saving: false,
      error,
    })),
    on(EscalationConfigurationActions.setEscalationEnabled, (state, { enabled }) => ({
      ...state,
      escalationEnabled: enabled,
    })),
    on(EscalationConfigurationActions.updateEscalationLevel, (state, { levelId, changes }) => ({
      ...state,
      escalationLevels: state.escalationLevels.map((level) => {
        if (level.id !== levelId) {
          return level;
        }

        return {
          ...level,
          ...changes,
          alertRecipients: changes.alertRecipients ?? level.alertRecipients,
          escalateTo: changes.escalateTo ?? level.escalateTo,
          channels: changes.channels ? { ...level.channels, ...changes.channels } : level.channels,
        };
      }),
    })),
    on(EscalationConfigurationActions.clearError, (state) => ({
      ...state,
      error: null,
    })),
    on(EscalationConfigurationActions.clearSuccessMessage, (state) => ({
      ...state,
      successMessage: null,
    })),
  ),
});

export const {
  name: escalationConfigurationFeatureKey,
  reducer: escalationConfigurationReducer,
  selectConfigurationId,
  selectEscalationEnabled,
  selectEscalationLevels,
  selectLoading,
  selectSaving,
  selectError,
  selectSuccessMessage,
} = escalationConfigurationFeature;
